import { FunctionComponent, HTMLAttributes, ReactNode } from 'react';
import styled from 'styled-components';
import { MOBILE_DEVICE } from '../constants/styles';

type CategoryHeadingProps = HTMLAttributes<HTMLHeadingElement> & {
    children?: ReactNode;
};

export const Container = styled.h2`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 23px;
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  line-height: 23px;
  color: #444444;
  
  @media ${MOBILE_DEVICE} {
    color: #999999;
  }
`;

const CategoryHeading: FunctionComponent<CategoryHeadingProps> = ({
    children,
    ...props
}) => {
    return (
        <Container {...props}>{children}</Container>
    );
};

export default CategoryHeading;